import React from "react";
import { IonItem, IonLabel, IonAccordion } from "@ionic/react";

export interface Props {}

const ResultsHelp: React.FC<Props> = () => {
  return (
    <IonAccordion value="ResultsHelp">
      <IonItem slot="header" color="light">
        <IonLabel>Using Qwizard Results</IonLabel>
      </IonItem>
      <div className="ion-padding" slot="content">
        <p>
          Qwizard&rsquo;s main point of difference relates to how results are
          used &ndash; live results during an event and online after an event.
          This helps to improvement the engagement with players. It is important
          that hosts emphasise these features.
        </p>
        <ul>
          <li>
            Rankings &ndash; After two events Qwizard teams earn a national
            ranking. These rankings are adjusted for team size. Therefore,
            entering team player numbers is important.
          </li>
          <li>
            Pie charts and bar graphs &ndash; Only Qwizard presents live
            graphical results. Explain the graphs and refer to them to create a
            competitive quiz. Share the results positively.
          </li>
          <li>
            • Team credits – where just one team answers a question correctly
            they will be acknowledged on screen with a &apos;Team credit&apos;.
            Use this information to provide positive feedback. (A minimum of 4
            teams applies for this feature).
          </li>
          <li>
            Email addresses &ndash; Teams who have provided an email address
            will receive a summary of their quiz results via email after the
            event and an opportunity to track their results. Collecting email
            addresses is encouraged since it further engages your teams.
          </li>
          <li>
            Finalising results &ndash; By clicking on &lsquo;Finalise
            Results&rsquo; at the end of your quiz Qwizard will send all the
            results to the qwizard.net website and issue emails to the teams
            about their results. Do this only once! Finalising more that once
            will send out multiple emails and effect team rankings.
          </li>
          <li>
            Online team results &ndash; After Finalising your event teams can
            refer to a list of all teams online, seeing how they rank across all
            Qwizard venues on the same day. You can view all the results at
            qwizard.net/results, then click on the date.
          </li>
          <li>
            Team Dashboards &ndash; Teams can choose to set up a Dashboard to
            collect and provide analysis on their quiz results. The option to
            set up a Dashboard is provided via a link within the team email. The
            Team Dashboards also allow teams to share results with other team
            members and review all of the questions from the quiz.
          </li>
          <li>
            Current Questions &amp; Facebook &ndash; At all regular events
            Qwizard supplies topical, hot-of-the-press questions - identified
            with the CQ stamp. At least 2 of your weekly CQ&rsquo;s will relate
            to clues that are supplied on the Qwizard Facebook page every Monday
            morning.
          </li>
        </ul>
      </div>
    </IonAccordion>
  );
};

export default ResultsHelp;
